// @flow

export default class {
  year: ?number;
  month: ?number;
  wave: number;

  constructor(year: ?number = null, month: ?number = null) {
    this.year = year;
    this.month = month;
    this.wave = 0;
  }

  get season() {
    const shiftedMonth = (this.month || 3) % 12;

    if (shiftedMonth >= 0 && shiftedMonth <= 2) {
      return 'winter';
    } else if (shiftedMonth >= 3 && shiftedMonth <= 5) {
      return 'spring';
    } else if (shiftedMonth >= 6 && shiftedMonth <= 8) {
      return 'summer';
    } else if (shiftedMonth >= 9 && shiftedMonth <= 11) {
      return 'autumn';
    }
  }

  next(): this {
    let year = parseInt(this.year);
    let month = parseInt(this.month);
    const today = new Date();

    if (isNaN(year)) {
      year = today.getFullYear();
    }

    if (isNaN(month)) {
      month = today.getMonth();
    }

    month += 1;

    if (month > 12) {
      year++;
      month = 1;
    }

    this.year = year;
    this.month = month;
    this.wave++;

    return this;
  }
}



// WEBPACK FOOTER //
// ./src/lib/virtual_time/virtual_time.js